import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Returns null while loading; { all, ids:Set } afterwards
export function useAccess() {
  const { status } = useAuth();
  const [access, setAccess] = useState(null);
  useEffect(() => {
    if (status !== "authenticated") return;
    api.get("/me/access").then((r) => setAccess({ all: r.data.all, ids: new Set(r.data.subject_ids) }));
  }, [status]);
  const can = (sid) => !access || access.all || access.ids.has(sid);
  return { access, can };
}
